import React from "react";
import { Helmet } from "react-helmet";
import Navbar from "./Navbar";
import Hero from "./Hero";
import ThurentServices from "./ThurentServices";
import HowDoesItWork from "./HowDoesItWork";
import ThurentCategories from "./ThurentCategories";
import Footer from "./Footer";
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { eventServicesSeoMappings } from "./Services/seoMappings";

function ThurentHome({ serviceType: propServiceType = "default" }) {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get serviceType from EITHER query param OR prop
  const params = new URLSearchParams(location.search);
  const queryServiceType = params.get("service");
  
  // Priority: Query param > Prop
  const finalServiceType = queryServiceType || propServiceType;
  
  // Get SEO data
  const seoData = eventServicesSeoMappings[finalServiceType] || eventServicesSeoMappings.default;

  useEffect(() => {
    // Redirect mapping for service types
    const serviceRedirects = {
      "event-organisers": "/tents",
      "event-planning-companies": "/tents",
      "home-event-services": "/tents",
      "event-services-home": "/tents",
      "corporate-event-planners": "/tents",
      "party-planners": "/tents",
      "event-equipment-rental": "/services/equipment",
      "event-planner-website": "/",
      "event-furniture-rental": "/services/furniture",
      
      // Add mappings for other service types from your seoRoutesConfig
      "tent-house-near-me": "/tents",
      "tent-house-rental": "/tents",
      "tents-on-rent": "/tents",
      "chair-table-rentals": "/tents",
      "home-catering-near-me": "/service/book-catering",
      "catering-at-home": "/service/book-catering",
      "caterers-india": "/service/book-catering",
      "book-catering": "/service/book-catering",
      "local-catering": "/service/book-catering",
      "affordable-caterer": "/service/book-catering",
      "pandit-online": "/service/hire-a-priest",
      "hire-priest": "/service/hire-a-priest",
      "online-puja": "/service/hire-a-priest",
      "pooja-booking": "/service/hire-a-priest",
      "book-puja": "/service/hire-a-priest",
      "invitation-maker": "/service/invite",
      "create-invitation": "/service/invite",
      "evite-cards": "/service/invite",
      "card-invitation-maker": "/service/invite",
      "digital-invitation": "/service/invite",
    };

    // Only redirect if not on the home page already
    if (serviceRedirects[finalServiceType] && finalServiceType !== "default") {
      navigate(serviceRedirects[finalServiceType], { 
        replace: true,
        state: { seoType: finalServiceType }
      });
    }
  }, [finalServiceType, navigate]);

  return (
    <>
      <Helmet>
        <title>{seoData.title}</title>
        <meta name="description" content={seoData.description} />
        <meta name="keywords" content={seoData.keywords} />
      </Helmet>
      
      <Navbar />
      <Hero />
      <ThurentServices />
      <HowDoesItWork />
      <ThurentCategories />
      <Footer />
    </>
  );
}

export default ThurentHome;